import { convertTimestampToDateString } from '../../utils/dates'

const calcAvailability = (availableFrom: number) => {
    const now = new Date().getTime() / 1000
    return availableFrom < now ? 'Now' : convertTimestampToDateString(availableFrom)
}

export { calcAvailability }
